import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrapper-stepper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "titleDD" }, "Proceso de conocimiento del cliente", -1)
const _hoisted_3 = { class: "stepper" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-item-counter" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-item-counter" }, null, -1)
const _hoisted_6 = { class: "stepper-content" }
const _hoisted_7 = { class: "stepper-pane" }
const _hoisted_8 = { class: "stepper-pane" }
const _hoisted_9 = { class: "stepper-pane" }
const _hoisted_10 = { class: "stepper-pane" }
const _hoisted_11 = { class: "stepper-pane" }
const _hoisted_12 = { class: "controls" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "pep-dialog" }, [
  /*#__PURE__*/_createElementVNode("b", null, "¿Sabías qué es el PEP? ")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "¿Eres PEP o tienes vínculos familiares con un PEP?")
], -1)
const _hoisted_15 = { class: "dialog-footer" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "pep-dialog" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Composición Accionaria ")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "¿Cuentas con accionistas o asociados a tu empresa?")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_contacto = _resolveComponent("info-contacto")!
  const _component_pep = _resolveComponent("pep")!
  const _component_info_cliente = _resolveComponent("info-cliente")!
  const _component_info_financiera = _resolveComponent("info-financiera")!
  const _component_info_adicional = _resolveComponent("info-adicional")!
  const _component_info_representante_titular = _resolveComponent("info-representante-titular")!
  const _component_info_representante_suplente = _resolveComponent("info-representante-suplente")!
  const _component_info_representante_pep = _resolveComponent("info-representante-pep")!
  const _component_info_accionista_natural = _resolveComponent("info-accionista-natural")!
  const _component_info_pep_accionista_natural = _resolveComponent("info-pep-accionista-natural")!
  const _component_info_accionista_juridico = _resolveComponent("info-accionista-juridico")!
  const _component_info_beneficiario_accionista_juridico = _resolveComponent("info-beneficiario-accionista-juridico")!
  const _component_info_pep_accionista_juridico = _resolveComponent("info-pep-accionista-juridico")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PasosNatural, (item) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["stepper-item", {
          current: _ctx.store.state.ddModule.step == item.value,
          success: _ctx.store.state.ddModule.step > item.value,
        }]),
            key: item.value
          }, [
            _hoisted_4,
            _withDirectives(_createElementVNode("span", { class: "stepper-item-title" }, _toDisplayString(item.label), 513), [
              [_vShow, _ctx.store.state.ddModule.step == item.value]
            ])
          ], 2)), [
            [_vShow, _ctx.validaTipoPersona === 'Natural' || _ctx.validaTipoPersona === 'Extranjera']
          ])
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PasosJuridico, (item) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["stepper-item", {
          current: _ctx.store.state.ddModule.step == item.value,
          success: _ctx.store.state.ddModule.step > item.value,
        }]),
            key: item.value
          }, [
            _hoisted_5,
            _withDirectives(_createElementVNode("span", { class: "stepper-item-title" }, _toDisplayString(item.label), 513), [
              [_vShow, _ctx.store.state.ddModule.step == item.value]
            ])
          ], 2)), [
            [_vShow, _ctx.validaTipoPersona === 'Jurídica']
          ])
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _createVNode(_component_info_contacto, {
            parametricas: _ctx.parametricas,
            scopeContacto: _ctx.scopeContacto,
            ref: "contactoRef",
            class: "width-step"
          }, null, 8, ["parametricas", "scopeContacto"])
        ], 512), [
          [_vShow, _ctx.store.state.ddModule.step == _ctx.SECCION.CONTACTO]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          _withDirectives(_createVNode(_component_pep, {
            scopePep: _ctx.scopePep,
            ref: "pepRef",
            parametricas: _ctx.parametricas
          }, null, 8, ["scopePep", "parametricas"]), [
            [_vShow, _ctx.mostrarPEP]
          ])
        ], 512), [
          [_vShow, _ctx.store.state.ddModule.step == _ctx.SECCION.PEP]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_9, [
          _withDirectives(_createVNode(_component_info_cliente, {
            parametricas: _ctx.parametricas,
            scopeCliente: _ctx.scopeCliente,
            DeshabilitarCamposJuridicos: _ctx.validaTipoPersona,
            ref: "clienteRef",
            class: "width-step"
          }, null, 8, ["parametricas", "scopeCliente", "DeshabilitarCamposJuridicos"]), [
            [_vShow, _ctx.mostrarCliente]
          ])
        ], 512), [
          [_vShow, _ctx.store.state.ddModule.step == _ctx.SECCION.CLIENTE]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_10, [
          _createVNode(_component_info_financiera, {
            scopeFinanciera: _ctx.scopeFinanciera,
            ref: "FinancieraRef",
            class: "width-step"
          }, null, 8, ["scopeFinanciera"])
        ], 512), [
          [_vShow, _ctx.store.state.ddModule.step == _ctx.SECCION.FINANCIERA]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_11, [
          _createVNode(_component_info_adicional, {
            parametricas: _ctx.parametricas,
            scopeAdicional: _ctx.scopeAdicional,
            ref: "AdicionalRef",
            class: "width-step"
          }, null, 8, ["parametricas", "scopeAdicional"])
        ], 512), [
          [_vShow, _ctx.store.state.ddModule.step == _ctx.SECCION.ADICIONAL]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(_component_info_representante_titular, {
            parametricas: _ctx.parametricas,
            scopeRepresentanteTitular: _ctx.scopeRepresentanteTitular,
            ref: "RepresentanteTitularRef",
            class: "width-step",
            onMostrarSeccionPepRT: _ctx.MostrarSeccionPepRT
          }, null, 8, ["parametricas", "scopeRepresentanteTitular", "onMostrarSeccionPepRT"]),
          _createVNode(_component_info_representante_suplente, {
            parametricas: _ctx.parametricas,
            scopeRepresentanteSuplente: _ctx.scopeRepresentanteSuplente,
            ref: "RepresentanteSuplenteRef",
            class: "width-step",
            onMostrarSeccionPepRS: _ctx.MostrarSeccionPepRS
          }, null, 8, ["parametricas", "scopeRepresentanteSuplente", "onMostrarSeccionPepRS"]),
          _createVNode(_component_info_representante_pep, {
            parametricas: _ctx.parametricas,
            scopeRepresentantePep: _ctx.scopeRepresentantePep,
            ref: "RepresentantePepRef",
            class: "width-step",
            style: _normalizeStyle([!_ctx.mostrarSeccionPep ? { opacity: '0.5' } : {}]),
            HabilitaCamposPep: _ctx.mostrarSeccionPep
          }, null, 8, ["parametricas", "scopeRepresentantePep", "style", "HabilitaCamposPep"])
        ], 512), [
          [_vShow, _ctx.store.state.ddModule.step == _ctx.SECCION.LEGAL]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _withDirectives(_createVNode(_component_info_accionista_natural, {
            parametricas: _ctx.parametricas,
            scopeInfoAccionista_Natural: _ctx.scopeInfoAccionista_Natural,
            ref: "InfoAccionista_NaturalRef",
            class: "width-step",
            onMostrarSeccionPepAN: _ctx.MostrarSeccionPepAN
          }, null, 8, ["parametricas", "scopeInfoAccionista_Natural", "onMostrarSeccionPepAN"]), [
            [_vShow, _ctx.mostrarAccionistasNaturales]
          ]),
          _withDirectives(_createVNode(_component_info_pep_accionista_natural, {
            parametricas: _ctx.parametricas,
            scopeInfoPepAccionista_Natural: _ctx.scopeInfoPepAccionista_Natural,
            ref: "InfoPepAccionista_NaturalRef",
            class: "width-step",
            style: _normalizeStyle([!_ctx.mostrarSeccionPepAN ? { opacity: '0.5' } : {}]),
            HabilitaCamposPepAN: _ctx.mostrarSeccionPepAN
          }, null, 8, ["parametricas", "scopeInfoPepAccionista_Natural", "style", "HabilitaCamposPepAN"]), [
            [_vShow, _ctx.mostrarAccionistasNaturales]
          ]),
          _withDirectives(_createVNode(_component_info_accionista_juridico, {
            parametricas: _ctx.parametricas,
            scopeInfoAccionista_Juridico: _ctx.scopeInfoAccionista_Juridico,
            ref: "InfoAccionista_JuridicoRef",
            class: "width-step"
          }, null, 8, ["parametricas", "scopeInfoAccionista_Juridico"]), [
            [_vShow, _ctx.mostrarAccionistasJuridicos]
          ]),
          _withDirectives(_createVNode(_component_info_beneficiario_accionista_juridico, {
            parametricas: _ctx.parametricas,
            scopeInfoBeneficiarioAccionista_Juridico: _ctx.scopeInfoBeneficiarioAccionista_Juridico,
            ref: "InfoBeneficiarioAccionista_JuridicoRef",
            class: "width-step",
            onMostrarSeccionPepAJ: _ctx.MostrarSeccionPepAJ
          }, null, 8, ["parametricas", "scopeInfoBeneficiarioAccionista_Juridico", "onMostrarSeccionPepAJ"]), [
            [_vShow, _ctx.mostrarAccionistasJuridicos]
          ]),
          _withDirectives(_createVNode(_component_info_pep_accionista_juridico, {
            parametricas: _ctx.parametricas,
            scopeInfoPepAccionista_Juridico: _ctx.scopeInfoPepAccionista_Juridico,
            ref: "InfoPepAccionista_JuridicoRef",
            class: "width-step",
            style: _normalizeStyle([!_ctx.mostrarSeccionPepAJ ? { opacity: '0.5' } : {}]),
            HabilitaCamposPepAJ: _ctx.mostrarSeccionPepAJ
          }, null, 8, ["parametricas", "scopeInfoPepAccionista_Juridico", "style", "HabilitaCamposPepAJ"]), [
            [_vShow, _ctx.mostrarAccionistasJuridicos]
          ])
        ], 512), [
          [_vShow, _ctx.store.state.ddModule.step == _ctx.SECCION.ACCIONISTA]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_button, {
          type: "success",
          plain: "",
          onClick: _ctx.RetrocederFormulario,
          disabled: _ctx.store.state.ddModule.step == 1
        }, {
          default: _withCtx(() => [
            _createTextVNode("Volver ")
          ]),
          _: 1
        }, 8, ["onClick", "disabled"]),
        _createVNode(_component_el_button, {
          type: "success",
          disabled: _ctx.finalizar,
          plain: "",
          onClick: _ctx.AvanzarFormulario
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.store.state.ddModule.step == _ctx.SECCION.ADICIONAL 
        ? 'Finalizar' 
        : 'Continuar'), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.pepDialogVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pepDialogVisible) = $event)),
      id: "el-dialog-pep"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { style: {"color":"#706262"} }, {
              default: _withCtx(() => [
                _createTextVNode(" PEP es la Persona Expuesta Políticamente, igualmente se catalogan como PEP las personas que tengan una sociedad conyugal, de hecho, o derecho con las personas expuestas políticamente nacionales o extranjeras, así como a sus familiares hasta el segundo grado de consanguinidad, segundo de afinidad y primero civil. ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { style: {"color":"#706262"} }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_15, [
          _createVNode(_component_el_button, {
            type: "success",
            plain: "",
            onClick: _ctx.AvanzarClienteIfNoPep
          }, {
            default: _withCtx(() => [
              _createTextVNode("No")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "success",
            plain: "",
            onClick: _ctx.AvanzarPEP
          }, {
            default: _withCtx(() => [
              _createTextVNode("Si")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.AccionistasDialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.AccionistasDialogVisible) = $event)),
      id: "el-dialog-Accionistas"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { style: {"color":"#706262"} }, {
              default: _withCtx(() => [
                _createTextVNode(" Se deben relacionar todos los accionistas o asociados que tengan directa o indirectamente el 5% o más de su capital social, aporte o participación. ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { style: {"color":"#706262"} }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.radioAccionistas,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.radioAccionistas) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: 1,
                  style: {"color":"#706262"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("No cuento con accionistas")
                  ]),
                  _: 1
                }),
                _hoisted_18,
                _createVNode(_component_el_radio, {
                  label: 2,
                  style: {"color":"#706262"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Si, cuento con accionistas naturales")
                  ]),
                  _: 1
                }),
                _hoisted_19,
                _createVNode(_component_el_radio, {
                  label: 3,
                  style: {"color":"#706262"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Si, cuento con accionistas jurídicos")
                  ]),
                  _: 1
                }),
                _hoisted_20,
                _createVNode(_component_el_radio, {
                  label: 4,
                  style: {"color":"#706262"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Si, cuento con ambos tipos de accionistas")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_21, [
          _createVNode(_component_el_button, {
            type: "success",
            plain: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.AvanzarAccionistas(_ctx.radioAccionistas)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Aceptar")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.mostrarSpinner)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          type: "modern"
        }))
      : _createCommentVNode("", true)
  ], 64))
}